import { PropsWithChildren, createContext, useMemo } from 'react';
import { useCurrentNode } from 'assets/js/pages/engage/workflows/hooks/useCurrentNode';
import { traverseUpTree } from 'assets/js/pages/engage/workflows/utils/helpers';
import { useReactFlowStore } from 'assets/js/pages/engage/workflows/utils/store';
import { NodeWithData } from 'assets/js/pages/engage/workflows/utils/types';
import { WorkflowActionTypeEnum } from 'constants/workflows';

interface IParentMessageContext {
    messageOptions: {
        id: string;
        label: string;
        type: WorkflowActionTypeEnum.SEND_EMAIL | WorkflowActionTypeEnum.SEND_SMS;
    }[];
}

const ParentMessageContext = createContext<IParentMessageContext>({
    messageOptions: [],
});

type ParentMessageProviderProps = PropsWithChildren;
const ParentMessageProvider = (props: ParentMessageProviderProps) => {
    const currentNode = useCurrentNode();
    const { nodes } = useReactFlowStore(({ nodes }) => ({ nodes }));
    const parentId = currentNode?.data?.parentId ?? null;
    const messageOptions = useMemo(() => {
        return { messageOptions: getParentMessages(nodes, parentId) };
    }, [nodes, parentId]);

    return <ParentMessageContext.Provider value={messageOptions} {...props} />;
};

const getParentMessages = (nodes: NodeWithData[], parentId: string | null) => {
    const messages: IParentMessageContext['messageOptions'] = [];
    traverseUpTree(nodes, parentId, node => {
        if (
            node.data?.type === WorkflowActionTypeEnum.SEND_EMAIL ||
            node.data?.type === WorkflowActionTypeEnum.SEND_SMS
        ) {
            if (node.data.messageId && node.data.formData?.values.internal_name) {
                messages.push({
                    id: node.data.messageId.toString(),
                    label: node.data.formData?.values.internal_name,
                    type: node.data.type,
                });
            }
        }
    });
    return messages;
};

export { ParentMessageProvider, ParentMessageContext };
